import React, { Component } from 'react';

class Service extends Component {
    render() {
        return (
            <div>
           
            {/*::breadcrumb part start::*/}
            <section className="breadcrumb blog_bg">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="breadcrumb_iner">
                      <div className="breadcrumb_iner_item">
                        <h2> services </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/*::breadcrumb part start::*/}
            {/*::service part end::*/}
            <section className="service_part section-padding">
              <div className="container">
                <div className="row justify-content-between align-items-center">
                  <div className="col-lg-7 col-xl-6">
                    <div className="section_tittle">
                      <h2>our <span>services</span></h2>
                    </div>
                    <div className="service_part_iner">
                      <div className="row">
                        <div className="col-lg-6 col-sm-6">
                          <div className="single_service_text ">
                            <img src="img/icon/service_1.svg" alt="" />
                            <h4>house Planning</h4>
                            <p>Lorem ipsum dolor sit amet consectetur elit seiusmod tempor incididunt </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                          <div className="single_service_text">
                            <img src="img/icon/service_2.svg" alt="" />
                            <h4>house Build</h4>
                            <p>Lorem ipsum dolor sit amet consectetur elit seiusmod tempor incididunt</p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                          <div className="single_service_text">
                            <img src="img/icon/service_3.svg" alt="" />
                            <h4>Design&amp;
                              Build</h4>
                            <p>Lorem ipsum dolor sit amet consectetur elit seiusmod tempor incididunt</p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                          <div className="single_service_text">
                            <img src="img/icon/service_4.svg" alt="" />
                            <h4>Design&amp;
                              Build</h4>
                            <p>Lorem ipsum dolor sit amet consectetur elit seiusmod tempor incididunt</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-10">
                    <div className="service_text">
                      <h2>Hello City We are
                        leader in <span> Services.</span></h2>
                      <p>Lorem ipsum dolor sit amet, consectetur adipi scing elit,
                        sed do eiusmodtemporincididunt u labore et dolore magna aliqua.
                        Quis ipsum pendisse ultrices gravida. Risus commodo viverra
                        maecenas accumsan lacus vel </p>
                      <a href="service.html" className="btn_1">learn more</a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/*::service part end::*/}
                       {/*::footer_part start::*/}
            <footer className="footer_part">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="footer_logo">
                      <a href="index.html" className="footer_logo_iner"> <img src="img/footer_logo.png" alt="#" /> </a>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-3">
                    <div className="single_footer_part">
                      <h4>About Us</h4>
                      <p>Heaven fruitful doesn't over lesser days appear creeping seasons so behold bearing days open
                      </p>
                      <div className="footer_icon social_icon">
                        <ul className="list-unstyled">
                          <li><a href="#" className="single_social_icon"><i className="fab fa-facebook-f" /></a></li>
                          <li><a href="#" className="single_social_icon"><i className="fab fa-twitter" /></a></li>
                          <li><a href="#" className="single_social_icon"><i className="fas fa-globe" /></a></li>
                          <li><a href="#" className="single_social_icon"><i className="fab fa-behance" /></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-3">
                    <div className="single_footer_part">
                      <h4>Contact Info</h4>
                      <p>Address : Your address goes
                        here, your demo address.</p>
                      <p>Phone : +8880 44338899</p>
                      <p>Email : info@colorlib.com</p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-3">
                    <div className="single_footer_part">
                      <h4>Important Link</h4>
                      <ul className="list-unstyled">
                        <li><a href="#"> WHMCS-bridge</a></li>
                        <li><a href="#">Search Domain</a></li>
                        <li><a href="#">My Account</a></li>
                        <li><a href="#">Shopping Cart</a></li>
                        <li><a href="#">Our Shop</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-3">
                    <div className="single_footer_part">
                      <h4>Newsletter</h4>
                      <p>Heaven fruitful doesn't over lesser in days. Appear creeping seasons deve behold bearing days
                        open
                      </p>
                      <div id="mc_embed_signup">
                        <form target="_blank" action="https://spondonit.us12.list-manage.com/subscribe/post?u=1462626880ade1ac87bd9c93a&id=92a4423d01" method="get" className="subscribe_form relative mail_part" required>
                          <input type="email" name="email" id="newsletter-form-email" placeholder="Email Address" className="placeholder hide-on-focus"  required />
                          <button type="submit" name="submit" id="newsletter-submit" className="email_icon newsletter-submit button-contactForm"><i className="far fa-paper-plane" /></button>
                          <div className="mt-10 info" />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-lg-12">
                    <div className="copyright_text text-center">
                      <p>{/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
                        Copyright © All rights reserved | This template is made with <i className="fa fa-heart" aria-hidden="true" /> by <a href="https://colorlib.com" target="_blank">Colorlib</a>
                        {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}</p>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
            {/*::footer_part end::*/}
          </div>
        );
    }
}

export default Service;